import { render, staticRenderFns } from "./GoodsText.vue?vue&type=template&id=9d585426&scoped=true&"
import script from "./GoodsText.vue?vue&type=script&lang=js&"
export * from "./GoodsText.vue?vue&type=script&lang=js&"
import style0 from "./GoodsText.vue?vue&type=style&index=0&id=9d585426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d585426",
  null
  
)

export default component.exports